import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';

GoogleAnalytics.initialize(process.env.REACT_APP_ANALYTICS_ID);

const withTracker = (WrappedComponent, options = {}) => {
    const trackPage = page => {
        GoogleAnalytics.set({
            page,
            ...options
        });

        if (process.env.REACT_APP_ANALYTICS_ENABLED === 'true') {
            GoogleAnalytics.pageview(page);
        }
    };

    // eslint-disable-next-line
    const HOC = class extends Component {
        componentDidMount() {
            const page =
                // eslint-disable-next-line
                this.props.location.pathname + this.props.location.search;
            trackPage(page);
        }

        componentDidUpdate(prevProps) {
            const {
                location: { pathname, search }
            } = this.props;
            const currentPage =
                prevProps.location.pathname + prevProps.location.search;
            const nextPage = pathname + search;

            if (currentPage !== nextPage) {
                trackPage(nextPage);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return HOC;
};

export default withTracker;
